























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Toast, Lazyload } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import SearchBar from '@/components/next/SearchBar.vue';
import { getVoteList1, getPrizeList } from '../api';
Vue.use(List).use(Lazyload);

@Component({
  components: {
    SearchBar,
  },
})
export default class ListPage extends Vue {
  keyword = '';
  show = true;
  page = 1;
  loading = false;
  finished = false;
  list: any[] = [];
  activeGroupItemIndex = 0;
  typesign: string = '0';
  loadinggroup = false;
  // intonowx: boolean = new Date().getTime() < 1700495999000; // 1700495999000  2023-11-20 23:59:59    1700409600000 2023-11-20 00:00:00
  intonowx: boolean = new Date().getTime() < 1701014399000; // 1701014399000  2023-11-26 23:59:59
  img: any[] = [
    {
      url: require('../assets/list-bg1.png'),
    },
    {
      url: require('../assets/list-bg2.png'),
    },
  ];
  mounted() {
    this.typesign = this.$route.query.type + '';
  }
  @Watch('$route.query.type', { immediate: true })
  typechange(newval: any, oldval: any) {
    this.onSearch();
  }
  async onGetVoteList() {
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    let ret: any;
    ret = await getVoteList1(
      this.page,
      this.$route.query.type + '',
      this.$route.query.cityname + '',
    );
    console.log('ret:', ret);
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.list = [...this.list, ...ret.data];
      this.page++;
    } else {
      this.loadinggroup = false;
      this.finished = true;
    }
  }

  onSearch() {
    this.reset();
    this.onGetVoteList();
  }

  onClear() {
    this.reset();
    this.onGetVoteList();
  }
  returnBack() {
    this.$router.go(-1);
  }
  reset() {
    this.loading = false;
    this.page = 1;
    this.list = [];
    this.finished = false;
  }
  onEntryClick() {
    location.href = 'http://h5.cqcb.com/c/wnlw/afxv/index.html';
  }

  onGroupItemChange(index: number) {
    this.activeGroupItemIndex = index;
    this.reset();
    this.onGetVoteList();
  }
}
